// Copyright (c) 2017 Comsearch, Inc., All rights reserved

// which column to sort on.
// NOTE - if you want to sort rows based on form data,
// here's where, you handle that.
export const getSortColByFormValues = formData => 'pathIndex'
